import React, { useState } from "react";

import {
  Box,
  Paper,
  Stack,
  TextField,
  Button,
  Collapse,
  IconButton,
  MenuItem,
  Typography,
} from "@mui/material";

import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";

import { useTranslation } from "react-i18next";

const EmployeeFilters = ({
  filters,
  setFilters,
  onReset,
  departments = [],
}) => {
  const { t, i18n } = useTranslation("UserManagement");

  const [open, setOpen] = useState(false);

  const handleChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Paper
      elevation={1}
      sx={{
        mb: 3,
        borderRadius: 3,
        overflow: "hidden",
      }}
    >
      {/* HEADER FILTER */}

      <Box
        sx={{
          px: 2,
          py: 1.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",

          background: "linear-gradient(135deg,#1976d2,#42a5f5)",
          color: "white",
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <FilterAltRoundedIcon />
          <Typography variant="h6" fontWeight={700} color="inherit">
            {t("Filters")}
          </Typography>
        </Stack>

        <IconButton
          onClick={() => setOpen(!open)}
          sx={{
            color: "white",
            transition: "0.25s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            "&:hover": {
              bgcolor: "rgba(255,255,255,0.15)",
            },
          }}
        >
          <FilterAltRoundedIcon />
        </IconButton>
      </Box>

      <Collapse in={open}>
        <Box
          sx={{
            p: 2,
          }}
        >
          <Stack
            direction={{
              xs: "column",
              md: "row",
            }}
            spacing={2}
          >
            {/* SEARCH */}

            <TextField
              fullWidth
              label={t("SearchEmployee")}
              placeholder={t("SearchEmployeePlaceholder")}
              value={filters.search || ""}
              onChange={(e) => handleChange("search", e.target.value)}
            />

            {/* DEPARTMENT */}

            <TextField
              select
              sx={{
                minWidth: 220,
              }}
              label={t("Department")}
              value={filters.department || ""}
              onChange={(e) => handleChange("department", e.target.value)}
            >
              <MenuItem value="">{t("All")}</MenuItem>

              {departments.map((department) => (
                <MenuItem key={department.id} value={department.textEn}>
                  {i18n.language === "FR"
                    ? department.textFr
                    : department.textEn}
                </MenuItem>
              ))}
            </TextField>

            {/* STATUS */}

            <TextField
              select
              sx={{
                minWidth: 200,
              }}
              label={t("Status")}
              value={filters.status || ""}
              onChange={(e) => handleChange("status", e.target.value)}
            >
              <MenuItem value="">{t("All")}</MenuItem>

              <MenuItem value="Active">{t("Active")}</MenuItem>

              <MenuItem value="Inactive">{t("Inactive")}</MenuItem>
            </TextField>

            {/* RESET */}

            <Button
              variant="outlined"
              startIcon={<RestartAltRoundedIcon />}
              onClick={onReset}
              sx={{
                whiteSpace: "nowrap",
              }}
            ></Button>
          </Stack>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default EmployeeFilters;
